import { DateOnly } from './date-only';
import { Pagination } from './pagination';
import { SearchSortOptions } from './search-sort-options';


/**
 * Filters model for anomalies.
 */
export interface PatientEventLogsFilter extends Pagination {
	dateFrom?: DateOnly | null;
	dateTo?: DateOnly | null;
	pinSiteCare: boolean;
	strutsAdj: boolean;
	prescrSync: boolean;
	other: boolean;
	sortOrder?: SearchSortOptions;
}


export enum EventLogField {
	anomalyDate = 'EventDate1',
	frameId = 'FrameID',
	effectiveDate = 'EventDate2',
	scheduledDate = 'EntityExpectedDate'
}